//React
import React, { Component } from "react";
import PropTypes from "prop-types";
//CSS
import "./loader.scss";

function Loader({ size, fixed }) {
	const classes = [fixed ?? false ? "loader--float" : "loader", size];
	return (
		<div className={classes.join(" ")}>
			<div className="lds-ring">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
	);
}
Loader.propTypes = {
	fixed: PropTypes.bool,
	size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]).isRequired,
};

export default Loader;
